import { store } from "..";

export const waitForDecision = () => {
    return new Promise((resolve) => {
      const checkDecision = () => {
        
        if (store.getState().Confirm_Modal_Slice.decision === true) {
          resolve(true);
          
        } 
        if(store.getState().Confirm_Modal_Slice.decision === false){
           resolve(false)
        }
        
        else {
          setTimeout(checkDecision, 10); // Check again after 10ms
        }
      };
      checkDecision();
    });
  };